import { Button, DataSource, Label, Layout, Panel, Step, Stepper, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionBilling extends Layout {
    buttonCommit: Button;
    buttonPick: Button;
    buttonProcess: Button;
    labelEmailSummary: Label;
    labelErrorHeader: Label;
    labelErrorSummary: Label;
    labelFaxSummary: Label;
    labelFtpHeader: Label;
    labelFtpSummary: Label;
    labelHeader1: Label;
    labelHeader2: Label;
    labelHeader3: Label;
    labelJobNumber: Label;
    labelLabel1: Label;
    labelLabel3: Label;
    labelLgxHeader: Label;
    labelLgxSummary: Label;
    labelPrintSummary: Label;
    layoutMonitor: Layout;
    panelEmail: Panel;
    panelError: Panel;
    panelFax: Panel;
    panelFtp: Panel;
    panelLgx: Panel;
    panelPrint: Panel;
    panelSummary: Panel;
    panelSummaryHeader: Panel;
    sourceImgdev: DataSource;
    sourceProcess: DataSource;
    sourceRenditionBilling: DataSource;
    stepResults: Step;
    stepReview: Step;
    stepSelect: Step;
    stepperMain: Stepper;
    tableRenditionBilling: Table;
    tableReview: Table;
    textboxImdvComnt1: Textbox;
    textboxImdvPort: Textbox;
}
